<template>
    <div class="default-range" :class="{error : errors.length}">
        <div class="default-range__body">
            <label class="default-range__label">{{ label }}</label>
            <div class="slider-range">
                <div class="slider-range__value">
                    <input class="slider-range__input"
                           v-model="value"
                           :required="required"
                           type="text"
                           :inputmode="inputmode"
                           v-mask="maskSettings"
                           :placeholder="placeholder"
                           :id="id"
                           :name="name"
                           :disabled="disabled">
                </div>
                <div class="slider-range__range" :data-min="min" :data-max="max" :data-start="start" :data-step="step" ref="rangeSlider"></div>
            </div>
        </div>
        <div class="default-range__error" v-if="errors.length">
            <span>{{ errors[0].$message }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "InputRange",
    props: {
        modelValue: {
            type: [String, Number],
            default: ''
        },
        id: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        inputmode: {
			type: String,
			default: 'numeric'
		},
        min: {
            type: [Number, String],
            default: 0
        },
        max: {
            type: [Number, String],
            default: 100
        },
        step: {
            type: [Number, String],
            default: 10
        },
        start: {
            type: [Number, String],
            default: 0
        },
        maskSettings: {
            type: [Object, String, null],
            default: null
        },
        errors: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        value: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            }
        }
    },
    mounted() {
        if (window.initNoUiSlider) {
            window.initNoUiSlider('.slider-range')
            if (this.$refs.rangeSlider.noUiSlider) {
                this.$refs.rangeSlider.noUiSlider.on('update', (values, handle) => {
                    this.value = values[handle]
                })
            }
        }
    },
}
</script>

<style scoped>

</style>